// extracted by css-extract-rspack-plugin
export default {"menuItem":"menu-styles-menuItem-63e7b31a","itemButton":"menu-styles-itemButton-b95050b3","menuItemSelected":"menu-styles-menuItemSelected-48885981"};